import type React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CognitoFormEmbed from "~/components/ui/cognitoFormEmbed";
import { CommonButton } from "~/components/ui/commonButton";
import BackLeftArrow from "~/images/back_arrow.svg?react";
import type { RootState } from "~/store";

const CreditPurchasePage: React.FC = () => {
  const navigate = useNavigate();
  const { organization, currentUser } = useSelector((state: RootState) => state.auth);

  if (!organization) return null;

  const isAdmin = currentUser?.role === "admin";

  if (!isAdmin) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl font-semibold text-gray-900">クレジット購入</h1>
        <p className="text-sm text-gray-700">クレジット購入は管理者のみ操作できます。</p>
        <div>
          <CommonButton variant="label" onClick={() => navigate(`/${organization.id}/billings`)}>
            戻る
          </CommonButton>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-2 mb-4">
        <button
          type="button"
          onClick={() => navigate(`/${organization.id}/billings`)}
          className="bg-transparent border-0 cursor-pointer flex items-center"
        >
          <BackLeftArrow />
        </button>
        <h1 className="text-2xl font-semibold text-gray-900">クレジット購入</h1>
      </div>
      <div style={{ height: "calc(100vh - 160px)", minHeight: "600px" }}>
        <CognitoFormEmbed paymentId={organization.payment_id} plan="クレジット購入" />
      </div>
    </div>
  );
};

export default CreditPurchasePage;
